import React, { createRef, useState } from 'react';
import TableView from '../../Components/tableView';
import constants from '../../constants';

// eslint-disable-next-line import/no-extraneous-dependencies
import { Container } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomAlert from '../../Components/CustomAlert';

const SensorsOwners = () => {
  const [showError, setShowError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const mainTable = createRef<TableView>();

  const { t } = useTranslation();

  const columns = [
    {
      title: t('SENSOR_ID'),
      field: 'sensorId',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('NAME'),
      field: 'ownerName',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('TYPE'),
      field: 'ownerType',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('MAIL'),
      field: 'ownerEmail',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('GEO'),
      field: 'geo',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('ACCOUNT_OWNER'),
      field: 'ownerAccount',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('ACCOUNT_INFRASTRUCTURE'),
      field: 'ownerInfrastructure',
      sorter: 'string',
      headerFilter: 'input'
    }
  ];

  return (
    <Container>
      <TableView
        t={t}
        ref={mainTable}
        api={constants.api.getSensorsOwners}
        id={'sensors-owner-list'}
        columns={columns}
      />
      <CustomAlert
        show={showError}
        message={errorMessage}
        onClose={() => {
          setShowError(false);
          setErrorMessage('');
        }}
      />
    </Container>
  );
};

export default SensorsOwners;
